var _circle, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 118,
    viewBox: "0 0 302 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.003,
    cy: 48.0027,
    r: 42.0027,
    fill: "url(#paint0_linear_350_34308)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_350_34308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 153.997,
    cy: 42.0027,
    r: 42.0027,
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_350_34308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 102,
    width: 90,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_34308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 254.003,
    cy: 48.0027,
    r: 42.0027,
    fill: "url(#paint1_linear_350_34308)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_350_34308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 259.998,
    cy: 42.0027,
    r: 42.0027,
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_350_34308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 102,
    width: 90,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_350_34308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0027,
    cy: 48.0027,
    r: 42.0027,
    fill: "url(#paint2_linear_350_34308)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_350_34308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.9979,
    cy: 42.0027,
    r: 42.0027,
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_350_34308)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 90,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_350_34308",
    x: 110.995,
    y: -1,
    width: 86.0054,
    height: 86.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_350_34308",
    x: -94,
    y: -98,
    width: 490,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_350_34308",
    x: 216.995,
    y: -1,
    width: 86.0054,
    height: 86.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_350_34308",
    x: 12,
    y: -98,
    width: 490,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_350_34308",
    x: 4.99512,
    y: -1,
    width: 86.0054,
    height: 86.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_350_34308",
    x: -200,
    y: -98,
    width: 490,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_350_34308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_350_34308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_34308",
    x1: 148.003,
    y1: 6,
    x2: 148.003,
    y2: 90.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29336B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_350_34308",
    x1: 254.003,
    y1: 6,
    x2: 254.003,
    y2: 90.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_350_34308",
    x1: 42.0027,
    y1: 6,
    x2: 42.0027,
    y2: 90.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B48B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B2929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_34308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.0003,
    height: 118,
    fill: "white",
    transform: "translate(212)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_350_34308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.0003,
    height: 118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.f42d8d3367dc32e36bc715e7a01355bc.svg";
export { ForwardRef as ReactComponent };